import {Component} from "preact";
import style from "./KeyPad.module.css";

export interface KeyPadProps {
	onType: (key: string) => void;
	disabled?: boolean;
	digits?: string[];
}

export const CodeDigits = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export class KeyPad extends Component<KeyPadProps> {
	render() {
		const {digits = CodeDigits, disabled, onType} = this.props;
		return (
			<div className={style.keyPad}>
				{digits.map(digit => (
					<KeyButton key={digit} value={digit} disabled={disabled} onType={onType}>
						{digit}
					</KeyButton>
				))}
			</div>
		);
	}
}

type KeyButtonProps = {
	value: string;
	onType: (key: string) => void;
	disabled?: boolean;
	class?: string;
};

class KeyButton extends Component<KeyButtonProps> {
	render() {
		const {value, disabled, children, "class": className} = this.props;
		return <button onClick={this.handleClick} disabled={disabled} class={className}>{children || value}</button>;
	}
	private handleClick = () => this.props.onType(this.props.value);
}
